import { SET_USER_REALM } from './types';
import { getViewStyle } from './view';
import { get } from 'global/lib/lodash';

export default function (realm) {
  return (dispatch, getState) => {
    const id = get(realm, 'id', get(getState(), 'auth.user.realm.id'));
    dispatch(getViewStyle(id));
    dispatch({ type: SET_USER_REALM, realm });
  };
}
